import BannerFraude from "./BannerFraude";
import BannerPurpleMetrics from "./BannerPurpleMetrics";
import React, { useEffect, useState } from "react";

import { Container, Dots, DotsContainer } from "./styles";

const componetsBanners = [
  {
    id: 0,
    Banner: BannerFraude,
  },
  {
    id: 1,
    Banner: BannerPurpleMetrics,
  },
];

const BannersSlider: React.FC = () => {
  const [activeBanner, setActiveBanner] = useState(0);

  useEffect(() => {
    const lengthBanner = componetsBanners.length - 1;

    setTimeout(() => {
      if (activeBanner + 1 > lengthBanner) {
        setActiveBanner(0);
      } else {
        setActiveBanner(activeBanner + 1);
      }
    }, 6000);
  }, [activeBanner]);

  return (
    <>
      {componetsBanners.map(({ id, Banner }) => (
        <Container
          key={id}
          className={id === activeBanner ? "slide active" : "slide"}
        >
          <Banner />
          <DotsContainer>
            {componetsBanners.map(({ id }) => (
              <Dots
                key={id}
                active={id === activeBanner}
                onClick={() => setActiveBanner(id)}
              />
            ))}
          </DotsContainer>
        </Container>
      ))}
    </>
  );
};

export default BannersSlider;
